import clsx from "clsx";
import React from "react";
import { KeyValue } from "../../../types/keyValue";
import CommonButton from "../../Button";

type Props = {
  items: KeyValue[];
  onChange: (selectedItem: KeyValue) => void;
  value: KeyValue;
  variantActive?:
    | "primary"
    | "secondary"
    | "grey"
    | "transparent"
    | "white"
    | "info"
    | "tertiary"
    | "select"
    | "default";
  variantInactive?:
    | "primary"
    | "secondary"
    | "grey"
    | "transparent"
    | "white"
    | "info"
    | "tertiary"
    | "default";
  className?: string;
  innerClassName?: string;
};

export default function RadioButtonGroup({
  items,
  onChange,
  value,
  className,
  innerClassName,
  variantActive = "primary",
  variantInactive = "grey",
}: Props) {
  return (
    <div className={clsx(["flex", className])}>
      {items.map((item) => (
        <CommonButton
          key={item.key}
          variant={
            value && value.key === item.key ? variantActive : variantInactive
          }
          onClick={() => {
            onChange?.(item);
          }}
          className={clsx([
            "w-full rounded-none h-12 whitespace-nowrap",
            innerClassName,
          ])}
          disabled={item.disabled}
          testId={item.key}
        >
          {item.value}
        </CommonButton>
      ))}
    </div>
  );
}
